module.exports = __webpack_public_path__ + "static/media/diary_unlock_getFreeBtn.d0545872.png";